import { patchData } from '../../utils'

export const patchTankMemo = async (tankId: string, memo: string) => {
  await patchData(`tank/${tankId}`, { memo: memo })
}
